module.exports = __webpack_public_path__ + "static/media/ref_table.be5e2d3a.jpg";